import React, { useState, useEffect } from 'react';
import {
    Typography, Button, MenuItem, TextField, IconButton, ListSubheader, Accordion, AccordionSummary, AccordionDetails, ButtonGroup, styled, Zoom,
    Tooltip, tooltipClasses, Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useTheme } from '@mui/material/styles';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import MostrarError from '../../components/AccionesPartes/MostrarError';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import './SubirYConsultar.css';
import dayjs from 'dayjs';

const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} disableInteractive />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}));

function SubirYConsultar() {

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    // Create a new Date object
    var today = new Date();

    // Get the current date components
    var year = today.getFullYear();
    var month = today.getMonth() + 1; // Note: Month is zero-based, so we add 1
    var day = today.getDate();

    // Format the date as a string (optional)
    var today = year + '-' + (month < 10 ? '0' : '') + month + '-' + (day < 10 ? '0' : '') + day;

    const [mensajeError, setMensajeError] = useState('');
    const [tipoError, setTipoError] = useState('');
    const [contadorError, setContadorError] = useState(1);
    const [estadoAlert, setEstadoAlert] = React.useState(false);

    //Variable que contendra el objeto PDF
    const [ubicacionPdf, setUbicacionPdf] = useState('');
    //Contiene unicamente el nombre
    const [nombrePdf, setNombrePdf] = useState('');

    let hoteles = localStorage.getItem('hoteles');

    const [hotelesLista, SetHotelesLista] = useState([]);

    const [hotelTrabajo, SetHotelTrabajo] = useState(0);
    const [tipoSelect, SetTipoSelect] = useState(0);
    const [estadoSelect, SetEstadoSelect] = useState(0);
    const [documentoSelect, SetDocumentoSelect] = useState([]);
    const [referenciaSelect, SetReferenciaSelect] = useState([]);
    const [relacionesTipo, setRelacionesTipo] = React.useState([]);
    const [mesesSelect, setMesesSelect] = useState(0);


    const [hotelBuscar, setHotelBuscar] = useState(0);


    const [estadoInicial, setEstadoInicial] = React.useState(true);

    const [contadorSpinner, setContadorSpinner] = React.useState(false);
    const [FDoc, setFDoc] = React.useState(today);
    const [FProx, setFProx] = React.useState();
    const [tipos, setTipos] = React.useState('');
    const [observaciones, setObservaciones] = React.useState('');
    const [referencias, setReferencias] = React.useState('');

    const [estados, setEstados] = React.useState([{ "id": "1", "nombre": "Favorable sin defectos" }, { "id": "2", "nombre": "Favorable con defectos leves" }, { "id": "3", "nombre": "Condicionada" }, { "id": "4", "nombre": "Negativa" }, { "id": "5", "nombre": "Negativa con parada obligatoria" }]);

    const [maquinas, setMaquinas] = React.useState('');
    const [maquinasFiltro, setMaquinasFiltro] = useState([...maquinas]);
    const [maquinasFiltroDocs, setMaquinasFiltroDocs] = useState([...maquinas]);

    const [filtroGrupo, setFiltroGrupo] = useState(null);
    const [filtroHotel, setFiltroHotel] = useState(null);

    const [grupos, setGrupos] = React.useState('');
    const [documentos, setDocumentos] = React.useState('');
    const [maquinasGrupos, setMaquinasGrupos] = React.useState('');
    const [vehiculos, setVehiculos] = React.useState('');
    const [electricas, setElectrica] = React.useState('');
    const [residuos, setResiduos] = React.useState('');
    const [piscinas, setPiscinas] = React.useState('');
    const [transformadores, setTransformadores] = React.useState('');
    const [tiposMaestro, setTiposMaestro] = React.useState('');
    const [aguas, setAguas] = React.useState('');
    const [combustibles, setCombustibles] = React.useState('');
    const [protecciones, setProteccion] = React.useState('');

    const [documentosLista, setDocumentosLista] = React.useState([]);
    const [documentosFiltrados, setDocumentosFiltrados] = React.useState([]);
    const [documentosFiltros, setDocumentosFiltros] = React.useState([]);
    const [referenciasDisponibles, setReferenciasDisponibles] = useState([]);


    const [estadoFiltro, setEstadoFiltrar] = React.useState(false);
    const [activoFiltro, setActivoFiltro] = React.useState(false);

    const cambiaHotelTrabajo = (event) => {
        if (event.target.name === 'id_hotel') {
            SetHotelTrabajo(event.target.value);
            setHotelBuscar(event.target.value);
            cambiarFiltroHotel(event.target.value);
        }
    };
    const cambiaHotelBuscar = (event) => {
        if (event.target.name === 'id_hotel_busca') {
            SetHotelTrabajo(event.target.value);
            setHotelBuscar(event.target.value);
            getDocumentosAll(event.target.value);
        }
    };
    const cambiaTipoSelect = (event) => {
        if (event.target.name === 'tipoSelect') {
            // console.log(event.target.value)
            SetTipoSelect(event.target.value);
        }
    };
    const cambiaEstadoSelect = (event) => {
        if (event.target.name === 'estadoSelect') {
            SetEstadoSelect(event.target.value);
        }
    };

    const findDocumentoById = (id) => {
        if (!id) return null;
        // Buscar primero en documentosFiltrados (si tiene datos), si no, en documentos
        const fuentes = [documentosFiltrados, documentos];
        for (const fuente of fuentes) {
            if (!fuente) continue;
            for (const grupoId of Object.keys(fuente)) {
                const doc = fuente[grupoId].find(d => String(d.id) === String(id));
                if (doc) return doc;
            }
        }
        return null;
    };
    const findDocumentoByIdFiltros = (id) => {
        if (!id) return null;
        const fuentes = [documentosFiltros, documentos];
        for (const fuente of fuentes) {
            if (!fuente) continue;
            for (const grupoId of Object.keys(fuente)) {
                const doc = fuente[grupoId].find(d => String(d.id) === String(id));
                if (doc) return doc;
            }
        }
        return null;
    };

    const cambiaDocumentoSelect = (event) => {
        if (event.target.name !== 'documentoSelect') return;

        const selectedId = event.target.value;

        // Si no hay id seleccionado ('' o 0) reseteamos
        if (!selectedId) {
            SetDocumentoSelect(null);
            SetReferenciaSelect([]);
            cambiarFiltroGrupo(0);
            return;
        }

        const doc = findDocumentoById(selectedId);
        if (doc) {
            SetDocumentoSelect(doc);             // guardamos el objeto completo
            SetReferenciaSelect([]);             // limpiamos referencias
            cambiarFiltroGrupo(doc.id_referencia_grupo || 0);
        } else {
            // fallback: guardar el id si no encontramos el objeto
            SetDocumentoSelect({ id: selectedId });
            SetReferenciaSelect([]);
            cambiarFiltroGrupo(0);
        }
    };

    const cambiaReferencia = (event) => {
        // console.log(event)
        if (event.target.name === 'referenciaSelect') {
            // console.log(event.target.value)
            SetReferenciaSelect(event.target.value);
        }
    };

    const mostrarError = (mensajeError, tipoError) => {
        setMensajeError(mensajeError);
        if (tipoError) {
            setTipoError(tipoError);
        } else {
            setTipoError("error");
        }
        setContadorError(contadorError + 1);
        setEstadoAlert(true);
        const timer2 = setTimeout(() => {
            setEstadoAlert(false);
        }, 3000);
        return () => clearTimeout(timer2);
    };
    const selecPdf = (event) => {
        if (event.target.files[0] !== undefined) {
            setUbicacionPdf(event.target.files[0]);
            setNombrePdf(event.target.files[0].name);
        } else {
            setUbicacionPdf("");
            setNombrePdf("");
        }
    };
    const borrarPdf = () => {
        //Vaciar el contenido del input de PDF.
        document.querySelector("#upload-pdf").value = "";
        setUbicacionPdf("");
        setNombrePdf("");
    };
    const ventanaPdf = (event) => {
        //Abrimos la imagen en una nueva ventana.
        window.open(URL.createObjectURL(ubicacionPdf));
    };
    // Función para aplicar los filtros y actualizar maquinasFiltro
    const aplicarFiltros = () => {
        let maquinasFiltradas = [...maquinas];

        if (filtroGrupo !== null) {
            maquinasFiltradas = maquinasFiltradas.filter(maquina => maquina.id_grupo === filtroGrupo);
        }

        if (filtroHotel !== null) {
            maquinasFiltradas = maquinasFiltradas.filter(maquina => maquina.id_hotel === filtroHotel);
        }

        setMaquinasFiltro(maquinasFiltradas);
    };

    // Función para cambiar el filtro por id_grupo
    const cambiarFiltroGrupo = (idGrupo) => {
        setFiltroGrupo(idGrupo);
    };

    // Función para cambiar el filtro por id_hotel
    const cambiarFiltroHotel = (idHotel) => {
        setFiltroHotel(idHotel);
        getInfoDocumentos(idHotel);
    };
    const cambiaObservaciones = (event) => {
        if (event.target.name === 'observaciones') {
            // console.log(event.target.value)
            setObservaciones(event.target.value);
        }
    };

    // Lo siento, se puede acortar, pero quiero acabar esto.. -CGB
    const compruebaInputs = () => {
        if (tipoSelect) {
            if (documentoSelect) {
                if (FProx) {
                    if (estadoSelect) {
                        if (nombrePdf) {
                            return true;
                        } else {
                            mostrarError('Documento no seleccionado.')
                            return false
                        }
                    } else {
                        mostrarError('Estado no seleccionado.')
                    }
                } else {
                    mostrarError('Fecha próxima no seleccionada.')
                }
            } else {
                mostrarError('Documento no seleccionado.')
                return false
            }
        } else {
            mostrarError('Tipo de documento no seleccionado.')
            return false
        }
    } //Lo siento de veras...

    const filtrosInicial = {
        id: '',
        nombre: '',
        observacion: '',
        f_registro_ini: '',
        f_registro_fin: '',
        f_documento_ini: '',
        f_documento_fin: '',
        f_proxima_ini: '',
        f_proxima_fin: '',
        estado: '', //Resultado
        tipo: '',
        documento: '',
        referencia: ''
    };
    const [filtros, setFiltros] = useState(filtrosInicial);
    const [tempFiltros, setTempFiltros] = useState(filtrosInicial);

    const mostrarFiltros = () => {
        setTempFiltros(filtros);
        setEstadoFiltrar(true);
    };
    const comprobarESCFiltrar = (event) => {
        if (event.keyCode === 27) {
            cancelFiltrar();
        }
    };
    const cancelFiltrar = () => {
        setTempFiltros(filtros);
        setEstadoFiltrar(false);
    };
    const borrarFiltros = () => {
        setFiltros(filtrosInicial);
        setTempFiltros(filtrosInicial);
        getDocumentosAll(hotelTrabajo);
    };

    const generarParams = (datos) => {
        let params = "";

        Object.keys(datos).forEach((key) => {
            const value = datos[key];

            if (value === '' || value === undefined || value === null) return;

            // Si es fecha: yyyy-mm-dd
            if (key.includes("f_") && value.includes("-")) {
                const partes = value.split("-");
                const fechaOrdenada = `${partes[0]}-${partes[1]}-${partes[2]}`;
                params += `${key}=${fechaOrdenada}|`;
                return;
            }

            // Campos que deben ir entre comillas
            if (key === "observacion" || key === "nombre") {
                params += `${key}='${JSON.stringify(value)}'|`;
                return;
            }

            // Si fuera array
            if (Array.isArray(value)) {
                if (value.length > 0) {
                    params += `${key}=${value.join(",")}|`;
                }
                return;
            }

            // Caso general
            params += `${key}=${value}|`;
        });

        return params;
    };

    const filtrarDocumentos = () => {
        // console.log(tempFiltros)
        setFiltros(tempFiltros);
        setEstadoFiltrar(false);

        // Comprobar filtros
        getDocumentosAll(hotelTrabajo);
    };

    // === Cambia el tipo seleccionado ===
    const handleTipoChange = (tipoId) => {
        setTempFiltros({
            ...tempFiltros,
            tipo: tipoId,
            documento: "",
            referencia: ""
        });

        // Filtrar los documentos según el tipo seleccionado
        if (!tipoId) {
            setDocumentosFiltros(documentos);
            setReferenciasDisponibles([]);
            return;
        }

        const documentosFiltradosTemp = {};

        if (tipoId && relacionesTipo && relacionesTipo[tipoId]) {
            // Convertimos los IDs válidos a string para comparar correctamente
            const idsValidos = relacionesTipo[tipoId].map(String);

            Object.keys(documentos).forEach((idGrupo) => {
                const docsFiltrados = documentos[idGrupo].filter((doc) =>
                    idsValidos.includes(doc.id)
                );
                if (docsFiltrados.length > 0) {
                    documentosFiltradosTemp[idGrupo] = docsFiltrados;
                }
            });
        }
        setDocumentosFiltros(documentosFiltradosTemp);
    };

    // === Cambia el documento seleccionado ===
    const handleDocumentoChange = (documentoId) => {
        setTempFiltros({
            ...tempFiltros,
            documento: documentoId,
            referencia: ""
        });

        if (!documentoId) {
            setReferenciasDisponibles([]);
            return;
        }

        const doc = findDocumentoByIdFiltros(documentoId);
        if (doc && doc.referencia) {
            cargarReferencias(doc.referencia);
        } else {
            setReferenciasDisponibles([]);
        }
    };

    // === Cambia la referencia seleccionada ===
    const handleReferenciaChange = (referenciaId) => {
        setTempFiltros({ ...tempFiltros, referencia: referenciaId });
    };

    // === Carga las referencias dinámicamente ===
    const cargarReferencias = (tipoReferencia) => {
        let lista = [];

        switch (tipoReferencia) {
            case "Maquinaria": lista = maquinas; break;
            case "Aguas": lista = aguas; break;
            case "Instalacion Electrica de Baja Tension": lista = electricas; break;
            case "Residuos": lista = residuos; break;
            case "Combustibles": lista = combustibles; break;
            case "Transformadores": lista = transformadores; break;
            case "Equipacion proteccion contra incendios": lista = protecciones; break;
            case "Vehiculos": lista = vehiculos; break;
            case "Piscinas": lista = piscinas; break;
            default: lista = [];
        }

        if (hotelBuscar && hotelBuscar > 0) {
            lista = lista.filter(item => item.id_hotel === hotelBuscar);
        }

        setReferenciasDisponibles(lista);
    };


    const registrar = () => {
        if (compruebaInputs()) {
            const fd = new FormData();
            const requestOptions = {
                method: 'POST',
                body: fd
            };
            // console.log(referenciaSelect)
            fd.append("f", "documentos.setNewDocumento");
            fd.append("token", localStorage.getItem('token'));
            fd.append("id_hotel", hotelTrabajo);
            if (tipoSelect >= 1 && tipoSelect <= 9) {
                fd.append("tipo", "Requisitos Legales");
            } else {
                fd.append("tipo", tipoSelect);
            }
            fd.append("documento", documentoSelect.id ? documentoSelect.id : documentoSelect.matricula);
            fd.append("grupo", documentoSelect.referencia);
            fd.append("referencia", referenciaSelect.id ? referenciaSelect.id : referenciaSelect.matricula ? referenciaSelect.matricula : '');
            fd.append("FDoc", FDoc);
            fd.append("FProx", FProx);
            fd.append("observaciones", observaciones);
            fd.append("archivo", ubicacionPdf);
            fd.append("estado", estadoSelect);
            fd.append("meses", mesesSelect);

            fetch('https://api.workers.grupotel.com/', requestOptions)
                .then(response => response.json())
                .then(result => {
                    // console.log(result);
                    let error = result.error;

                    if (error.id === 0) {
                        getDocumentosAll();
                    } else {
                        mostrarError(error.msg)
                    }
                })
        }
    }

    // Funcion para obtener documentos.
    const getDocumentosAll = (id_hotel = 0) => {

        let idHotel = localStorage.getItem('idHotelSeleccionado');
        if (estadoInicial) {
            if (idHotel) {
                setHotelBuscar(idHotel);
                id_hotel = idHotel
            }
        }
        if (id_hotel === 0 && hotelBuscar != 0) {
            id_hotel = hotelBuscar;
        }
        if (id_hotel != 0) {

            const params = generarParams(tempFiltros);

            const fd = new FormData();
            const requestOptions = {
                method: 'POST',
                body: fd
            };
            fd.append("f", "documentos.getDocumentosAll");
            fd.append("token", localStorage.getItem('token'));
            fd.append("id_hotel", id_hotel);
            // console.log("GET Documentos All")
            // console.log(params);
            fd.append("params", params);

            fetch('https://api.workers.grupotel.com/', requestOptions)
                .then(response => response.json())
                .then(result => {
                    // console.log(result);
                    let error = result.error;
                    setDocumentosLista(result.documentos)
                    if (error.id === 0) {

                    } else {
                        mostrarError(error.msg)
                    }
                })
        } else {
            setDocumentosLista([])
        }
    }

    const goToFile = (documento => {
        // console.log(documento)
        var url = 'https://api.workers.grupotel.com/documentos/';
        var id_hotel = documento.id_hotel;
        var id_documento = documento.id_documento;
        var id_referencia = documento.id_referencia;
        var id_referencia_grupo = documento.id_referencia_grupo;
        var fichero = documento.fichero;

        url = url + id_hotel + '/Requisitos Legales/' + id_referencia + '/' + fichero;
        window.open(url, '_blank');
    })

    const getInfoDocumentos = (id_hotel = 0) => {

        let listaHoteles = JSON.parse(hoteles);
        SetHotelesLista(listaHoteles);

        //Si tenemos un hotel guardado en el localStorage utilizando Ajustes.
        let idHotel = localStorage.getItem('idHotelSeleccionado');
        // console.log(listaHoteles);
        if (estadoInicial) {
            if (idHotel) {
                SetHotelTrabajo(idHotel);
                // setHotelBuscar(idHotel);
                setEstadoInicial(false);
                id_hotel = idHotel
            } else {
                console.log(listaHoteles);
            }
        }
        const fd = new FormData();
        const requestOptions = {
            method: 'POST',
            body: fd
        };
        //setDepartamentosLista('');
        fd.append("f", "documentos.getInfoDocumentos");
        fd.append("token", localStorage.getItem('token'));
        fd.append("id_hotel", id_hotel);
        // console.log("hotelTrabajo: ", id_hotel)

        fetch('https://api.workers.grupotel.com/', requestOptions)
            .then(response => response.json())
            .then(result => {
                // console.log(result)
                let error = result.error;

                if (error.id === 0) {
                    delete result.error;
                    // console.log(result)
                    setGrupos(result.grupo)
                    setRelacionesTipo(result.relaciones_tipo);
                    setDocumentos(result.documentos)
                    setReferencias(result.referencia)
                    setMaquinasGrupos(result.maquinas_grupos)
                    setMaquinas(result.maquinas)
                    setVehiculos(result.vehiculos)
                    setElectrica(result.electrica)
                    setResiduos(result.residuos)
                    setPiscinas(result.piscinas);
                    setTransformadores(result.transformadores)
                    setTiposMaestro(result.tipos_maestro)
                    setAguas(result.aguas)
                    setCombustibles(result.combustibles)
                    setProteccion(result.proteccion)

                    setTipos(Object.entries(result.tipo).map(([id, nombre]) => ({
                        id,
                        nombre
                    })));

                    const timer2 = setTimeout(() => {
                        setContadorSpinner(false)
                    }, 500);

                } else if (error.id >= 501 && error.id <= 510) {
                    localStorage.setItem('token', 'CADUCADO');
                    window.location.reload();
                } else {
                    mostrarError(error.msg)
                    console.log(error.msg)
                }
            })
            .catch(() => {
                mostrarError("No se ha podido obtener.")
                console.log('No se ha podido obtener.')
            })
    }

    useEffect(() => {
        getInfoDocumentos();
        getDocumentosAll();
    }, []);

    const estadosMap = React.useMemo(() => {
        const map = {};
        estados.forEach(e => map[e.id] = e.nombre);
        return map;
    }, [estados]);

    useEffect(() => {
        aplicarFiltros();
    }, [maquinas, filtroGrupo, filtroHotel]);

    useEffect(() => {
        const documentosFiltradosTemp = {};

        if (tipoSelect && relacionesTipo && relacionesTipo[tipoSelect]) {
            // Convertimos los IDs válidos a string para comparar correctamente
            const idsValidos = relacionesTipo[tipoSelect].map(String);

            Object.keys(documentos).forEach((idGrupo) => {
                const docsFiltrados = documentos[idGrupo].filter((doc) =>
                    idsValidos.includes(doc.id)
                );

                if (docsFiltrados.length > 0) {
                    documentosFiltradosTemp[idGrupo] = docsFiltrados;
                }
            });
        }
        setDocumentosFiltrados(documentosFiltradosTemp);
    }, [tipoSelect]);

    return (
        <div>
            <Accordion defaultExpanded className="subiryconsultar ">
                <AccordionSummary className="subiryconsultarHeader" expandIcon={<ExpandMoreIcon />} id="panel-header-1" aria-controls="panel-content-1">
                    <Typography variant="h5" component="div" className='centrar'>
                        Subir fichero
                    </Typography>
                </AccordionSummary>
                <AccordionDetails className='subiryconsultarContainer'>
                    <div className='subiryconsultarRow'>
                        <div className='dycinput '>
                            <TextField
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                label="Hotel"
                                name="id_hotel"
                                size="small"
                                value={hotelTrabajo ? hotelTrabajo : ""}
                                onChange={cambiaHotelTrabajo}
                                select
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                        }
                                    }
                                }}
                            >
                                {hotelesLista.length !== 0 ? hotelesLista.map((hotel) => (
                                    <MenuItem key={hotel.value} value={hotel.value} >
                                        {hotel.label}
                                    </MenuItem>
                                )) : ''}
                            </TextField>
                        </div>
                        <div className='dycinput '>
                            <TextField
                                fullWidth
                                defaultValue=""
                                variant="outlined"
                                margin="normal"
                                label="Tipo"
                                name="tipoSelect"
                                size="small"
                                value={tipoSelect ? tipoSelect : ""}
                                onChange={cambiaTipoSelect}
                                select
                                SelectProps={{
                                    MenuProps: {
                                        PaperProps: {
                                            sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                        }
                                    }
                                }}
                            >
                                <MenuItem value={0} key={0}>
                                </MenuItem>
                                {tipos.length !== 0 &&
                                    tipos.map((tipo) => (
                                        <MenuItem value={tipo.id} key={tipo.id}>
                                            {tipo.nombre}
                                        </MenuItem>
                                    ))}

                            </TextField>
                        </div>
                        <div className='dycinput '>
                            {hotelTrabajo > 0 ?
                                <TextField
                                    fullWidth
                                    defaultValue=""
                                    variant="outlined"
                                    margin="normal"
                                    label="Documento"
                                    name="documentoSelect"
                                    size="small"
                                    value={documentoSelect ? (documentoSelect.id ?? documentoSelect) : ""}
                                    onChange={cambiaDocumentoSelect}
                                    select
                                    SelectProps={{
                                        sx: { width: '100%' },
                                        MenuProps: {
                                            PaperProps: {
                                                sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                            }
                                        }
                                    }}
                                >
                                    {Object.keys(documentosFiltrados).map((categoria) => (
                                        [
                                            <ListSubheader key={`grp-${categoria}`} className="subHeaderNegrita">
                                                {grupos[categoria]?.nombre || 'Sin grupo'}
                                            </ListSubheader>,
                                            ...documentosFiltrados[categoria].map((documento) => (
                                                <MenuItem key={documento.id} value={documento.id}>
                                                    {documento.nombre}
                                                </MenuItem>
                                            ))
                                        ]
                                    ))}

                                </TextField>
                                :
                                <TextField
                                    fullWidth
                                    defaultValue=""
                                    variant="outlined"
                                    margin="normal"
                                    label="Documento"
                                    name="documentoSelect"
                                    size="small"
                                    disabled
                                    value={documentoSelect ? documentoSelect : ""}
                                    onChange={cambiaDocumentoSelect}
                                    select
                                    SelectProps={{
                                        sx: { width: '100%' },
                                        MenuProps: {
                                            PaperProps: {
                                                sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                            }
                                        }
                                    }}
                                ></TextField>
                            }

                        </div>
                        <div className='dycinput '>
                            {documentoSelect.length != 0 || documentoSelect != 0 ?
                                documentoSelect.referencia !== 'Hotel' ?
                                    <TextField
                                        defaultValue=""
                                        fullWidth
                                        variant="outlined"
                                        margin="normal"
                                        label="Referencia"
                                        name="referenciaSelect"
                                        size="small"
                                        value={referenciaSelect ? referenciaSelect : ""}
                                        onChange={cambiaReferencia}
                                        select
                                        SelectProps={{
                                            MenuProps: {
                                                PaperProps: {
                                                    sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                                }
                                            }
                                        }}
                                    >
                                        {/* === Maquinaria === */}
                                        {documentoSelect.referencia === "Maquinaria" &&
                                            (maquinasFiltro.length > 0 ? (
                                                maquinasFiltro.map((maquina) => (
                                                    <MenuItem value={maquina} key={maquina.id}>
                                                        {maquina.nombre}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>Ha de crear Máquinas al hotel</MenuItem>
                                            ))}
                                        {/* === Aguas === */}
                                        {documentoSelect.referencia === "Aguas" &&
                                            (aguas.length > 0 ? (
                                                aguas.map((agua) => (
                                                    <MenuItem value={agua} key={agua.id}>
                                                        {agua.nombre}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>El hotel no tiene Aguas</MenuItem>
                                            ))}

                                        {/* === Instalaciones eléctricas === */}
                                        {documentoSelect.referencia ===
                                            "Instalacion Electrica de Baja Tension" &&
                                            (electricas.length > 0 ? (
                                                electricas.map((electrica) => (
                                                    <MenuItem value={electrica} key={electrica.id}>
                                                        {electrica.nombre}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>
                                                    El hotel no tiene Instalaciones eléctricas
                                                </MenuItem>
                                            ))}

                                        {/* === Residuos === */}
                                        {documentoSelect.referencia === "Residuos" &&
                                            (residuos.length > 0 ? (
                                                residuos.map((residuo) => (
                                                    <MenuItem value={residuo} key={residuo.id}>
                                                        {residuo.nombre}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>El hotel no tiene Residuos</MenuItem>
                                            ))}

                                        {/* === Combustibles === */}
                                        {documentoSelect.referencia === "Combustibles" &&
                                            (combustibles.length > 0 ? (
                                                combustibles.map((combustible) => (
                                                    <MenuItem value={combustible} key={combustible.id}>
                                                        {combustible.nombre}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>El hotel no tiene Combustibles</MenuItem>
                                            ))}

                                        {/* === Transformadores === */}
                                        {documentoSelect.referencia === "Transformadores" &&
                                            (transformadores.length > 0 ? (
                                                transformadores.map((transformador) => (
                                                    <MenuItem value={transformador} key={transformador.id}>
                                                        {transformador.nombre}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>El hotel no tiene Transformadores</MenuItem>
                                            ))}

                                        {/* === Protección contra incendios === */}
                                        {documentoSelect.referencia ===
                                            "Equipacion proteccion contra incendios" &&
                                            (protecciones.length > 0 ? (
                                                protecciones.map((proteccion) => (
                                                    <MenuItem value={proteccion} key={proteccion.id}>
                                                        {proteccion.nombre}
                                                    </MenuItem>
                                                ))
                                            ) : (
                                                <MenuItem disabled>
                                                    El hotel no tiene Equipos de protección contra incendios
                                                </MenuItem>
                                            ))}
                                        {documentoSelect.referencia === 'Piscinas' &&
                                            piscinas.map((piscina) => (
                                                <MenuItem value={piscina} key={piscina.id}>{piscina.nombre}</MenuItem>
                                            ))
                                        }

                                        {/* === Vehículos === */}
                                        {documentoSelect.referencia === "Vehiculos" &&
                                            (vehiculos.length > 0 ? (
                                                vehiculos.map((vehiculo) =>
                                                    vehiculo.nombre ? (
                                                        <MenuItem value={vehiculo} key={vehiculo.id}>
                                                            {vehiculo.nombre}
                                                        </MenuItem>
                                                    ) : (
                                                        <MenuItem value={vehiculo} key={vehiculo.matricula}>
                                                            {vehiculo.marca} {vehiculo.modelo}
                                                        </MenuItem>
                                                    )
                                                )
                                            ) : (
                                                <MenuItem disabled>El hotel no tiene Vehículos</MenuItem>
                                            ))}
                                    </TextField>
                                    :
                                    <TextField
                                        defaultValue=""
                                        fullWidth
                                        variant="outlined"
                                        margin="normal"
                                        label="Referencia"
                                        name="referenciaSelect"
                                        size="small"
                                        value={referenciaSelect ? referenciaSelect : ""}
                                        onChange={cambiaReferencia}
                                        select
                                        disabled
                                        SelectProps={{
                                            MenuProps: {
                                                PaperProps: {
                                                    sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                                }
                                            }
                                        }}
                                    ></TextField>
                                :
                                <TextField
                                    defaultValue=""
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Referencia"
                                    name="referenciaSelect"
                                    size="small"
                                    value={referenciaSelect ? referenciaSelect : ""}
                                    onChange={cambiaReferencia}
                                    select
                                    disabled
                                    SelectProps={{
                                        MenuProps: {
                                            PaperProps: {
                                                sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                            }
                                        }
                                    }}
                                ></TextField>
                            }
                        </div>
                    </div>
                    <div className='subiryconsultarRow'>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <div className='dycinputfl '>
                                <DatePicker
                                    format="DD-MM-YYYY"
                                    name='FDoc'
                                    onChange={setFDoc}
                                    label="Fecha Documento"
                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                    defaultValue={dayjs()}
                                />
                            </div>
                            <div className='dycinputfl '>
                                <DatePicker
                                    format="DD-MM-YYYY"
                                    name='FProx'
                                    onChange={(setFProx)}
                                    label="Fecha Próxima"
                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                />
                            </div>
                            <div className='dycinputfl '>
                                <TextField
                                    fullWidth
                                    defaultValue=""
                                    variant="outlined"
                                    label="Resultado"
                                    name="estadoSelect"
                                    size="small"
                                    value={estadoSelect ? estadoSelect : ""}
                                    onChange={cambiaEstadoSelect}
                                    select
                                    SelectProps={{
                                        MenuProps: {
                                            PaperProps: {
                                                sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value={0} key={0}>
                                    </MenuItem>
                                    {estados.length !== 0 ? estados.map((estado) => (
                                        <MenuItem value={estado.id} key={estado.id}>
                                            {estado.nombre}
                                        </MenuItem>
                                    )) : ''}
                                </TextField>
                            </div>
                            <div className='dycinput '>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    className='dycobs'
                                    label="Observaciones"
                                    name='observaciones'
                                    value={observaciones}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    onChange={cambiaObservaciones}
                                />
                            </div>
                        </LocalizationProvider>
                    </div>
                    <div className='divFicheroRegistrar'>
                        {estadoSelect != 1 && estadoSelect != '' ?
                            <div className='dycinputfl'>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    label="Plazo Meses"
                                    value={mesesSelect}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Solo números
                                        if (/^\d*$/.test(value)) {
                                            setMesesSelect(value);
                                        }
                                    }}
                                    inputProps={{
                                        inputMode: "numeric",
                                        pattern: "[0-9]*",
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>
                            : ''
                        }
                        <div className='dycbotonera'>
                            <div className='dycbotoneraseparado'>
                                <div>
                                    <label htmlFor="upload-pdf" className=''>
                                        <input
                                            className='ocultar'
                                            accept=".pdf"
                                            id="upload-pdf"
                                            type="file"
                                            onChange={selecPdf}
                                        />
                                        <Button component='span' className='estiloDivider permiso' variant="contained">Subir Fichero</Button>
                                    </label>
                                    {nombrePdf ?
                                        <div>
                                            <Button className='nombrePdf' variant="text" onClick={ventanaPdf} >{nombrePdf ? nombrePdf : ''}</Button>
                                            <IconButton className='iconX' onClick={borrarPdf} >x</IconButton>
                                        </div>
                                        :
                                        <div>
                                        </div>
                                    }
                                </div>
                                {nombrePdf && tipoSelect && documentoSelect && FDoc && estadoSelect && ((Number(estadoSelect) != 1 && Number(mesesSelect) > 0) || (Number(estadoSelect) == 1)) ?
                                    <div>
                                        <Button onClick={registrar} component='span' className='estiloDivider permiso' variant="contained">Registrar</Button>
                                    </div>
                                    :
                                    <div>
                                        <Button disabled component='span' className='estiloDivider permiso' variant="contained">Registrar</Button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>

            <Accordion className='subiryconsultar'>
                <AccordionSummary className="subiryconsultarHeader" expandIcon={<ExpandMoreIcon />} id="panel-header-2" aria-controls="panel-content-2">
                    <Typography variant="h5" component="div" className='centrar'>
                        Ficheros
                    </Typography>
                </AccordionSummary>

                <AccordionDetails className='subiryconsultarContainer'>
                    <div className='dycinput '>
                        <TextField
                            fullWidth
                            variant="outlined"
                            margin="normal"
                            label="Hotel"
                            name="id_hotel_busca"
                            size="small"
                            value={hotelBuscar ? hotelBuscar : ""}
                            onChange={cambiaHotelBuscar}
                            select
                            SelectProps={{
                                MenuProps: {
                                    PaperProps: {
                                        sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                    }
                                }
                            }}
                        >
                            {hotelesLista.length !== 0 ? hotelesLista.map((hotel) => (
                                <MenuItem key={hotel.value} value={hotel.value} >
                                    {hotel.label}
                                </MenuItem>
                            )) : ''}
                        </TextField>

                        <ButtonGroup className="botonera divFiltrar" variant="contained" aria-label="outlined button group">
                            <HtmlTooltip
                                placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                                title={
                                    <React.Fragment>
                                        <Typography color="inherit">{"Filtrar"}</Typography>
                                    </React.Fragment>
                                }
                            >
                                <Button
                                    className={activoFiltro === true ? "boton filtro pintado" : "boton filtro"}
                                    onClick={mostrarFiltros}
                                >
                                    <FilterAltIcon className='icon-button' />
                                </Button>
                            </HtmlTooltip>
                        </ButtonGroup>
                    </div>
                    {/* <div className='subiryconsultarrow'>
                    </div> */}
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>
                                <TableCell>Documento</TableCell>
                                <TableCell>Observacion</TableCell>
                                <TableCell>Fecha Registro</TableCell>
                                <TableCell>Estado</TableCell>
                                <TableCell>Fecha Documento</TableCell>
                                <TableCell>Fecha Próxima</TableCell>
                                <TableCell>Fichero</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {documentosLista ? documentosLista.map((documento) => {
                                const documentoEncontrado = Object.values(documentos).flat().find(sdoc => sdoc.id === documento.id_documento);
                                const nombreDocumento = documentoEncontrado ? documentoEncontrado.nombre : 'Nombre no encontrado';
                                const nombreEstado = estadosMap[documento.estado] || "Estado desconocido";

                                const textoEstado = Number(documento.estado) === 1 ? nombreEstado : `${nombreEstado} (${documento.meses} meses)`;

                                return (
                                    <TableRow>
                                        <TableCell>{documento.id}</TableCell>
                                        <TableCell>{nombreDocumento}</TableCell>
                                        <TableCell>{documento.observaciones}</TableCell>
                                        <TableCell>{documento.fecha_registro}</TableCell>
                                        <TableCell>{textoEstado}</TableCell>
                                        <TableCell>{documento.fecha_documento}</TableCell>
                                        <TableCell>{documento.fecha_proxima}</TableCell>
                                        <TableCell><Button onClick={() => { goToFile(documento) }} fullWidth component='span' className=' permiso' variant="contained"><ContentPasteSearchIcon></ContentPasteSearchIcon></Button></TableCell>
                                    </TableRow>
                                )
                            }) : ''}
                        </TableBody>
                    </Table>
                </AccordionDetails>
            </Accordion>
            <MostrarError mensajeEr={mensajeError} tipoError={tipoError} contadorError={contadorError} estadoAlert={estadoAlert} />
            <Dialog fullScreen={fullScreen}
                open={estadoFiltro}
                onClose={comprobarESCFiltrar}
                aria-labelledby="responsive-dialog-title" id="dialogFiltroDocumentos">
                <DialogTitle>Filtrar Documentos</DialogTitle>
                <DialogContent>
                    <div>
                        <div className='subiryconsultarRow'>
                            {/* Id de registro fichero */}
                            <div className='dycinputFilter'>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    label="ID"
                                    value={tempFiltros.id}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Solo números
                                        if (/^\d*$/.test(value)) {
                                            setTempFiltros({ ...tempFiltros, id: value });
                                        }
                                    }}
                                    inputProps={{
                                        inputMode: "numeric",
                                        pattern: "[0-9]*",
                                    }}
                                    size="small"
                                    fullWidth
                                />
                            </div>

                            {/* === FILTRO: Estado (Resultado) === */}
                            <div className='dycinputFilter'>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Resultado"
                                    name="estado"
                                    id="estadoFiltro"
                                    size="small"
                                    value={tempFiltros.estado}
                                    onChange={(e) =>
                                        setTempFiltros({ ...tempFiltros, estado: e.target.value })
                                    }
                                    select
                                    SelectProps={{
                                        MenuProps: {
                                            PaperProps: {
                                                sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {estados.map((estado) => (
                                        <MenuItem key={estado.id} value={estado.id}>
                                            {estado.nombre}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </div>
                        <div className='subiryconsultarRow'>
                            {/* === FILTRO: Tipo === */}
                            <div className='dycinputFilter'>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Tipo"
                                    name="tipo"
                                    id="tipoFiltro"
                                    size="small"
                                    value={tempFiltros.tipo}
                                    onChange={(e) => handleTipoChange(e.target.value)}
                                    select
                                    SelectProps={{
                                        MenuProps: {
                                            PaperProps: {
                                                sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value=""></MenuItem>
                                    {tipos.length !== 0 &&
                                        tipos.map((tipo) => (
                                            <MenuItem key={tipo.id} value={tipo.id}>
                                                {tipo.nombre}
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </div>

                            {/* === FILTRO: Documento === */}
                            <div className='dycinputFilter'>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Documento"
                                    name="documento"
                                    id="documentoFiltro"
                                    size="small"
                                    value={tempFiltros.documento}
                                    onChange={(e) => handleDocumentoChange(e.target.value)}
                                    select
                                    disabled={!documentosFiltros || Object.keys(documentosFiltros).length === 0}
                                    SelectProps={{
                                        MenuProps: {
                                            PaperProps: { sx: { maxHeight: { sm: 36 * 8 + 8 } } }
                                        }
                                    }}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {documentosFiltros && Object.keys(documentosFiltros).map((grupoId) => (
                                        [
                                            <ListSubheader key={`grp-${grupoId}`} className="subHeaderNegrita">
                                                {grupos[grupoId]?.nombre || 'Sin grupo'}
                                            </ListSubheader>,
                                            ...documentosFiltros[grupoId].map((doc) => (
                                                <MenuItem key={doc.id} value={doc.id}>
                                                    {doc.nombre}
                                                </MenuItem>
                                            ))
                                        ]
                                    ))}
                                </TextField>
                            </div>

                            {/* === FILTRO: Referencia (dependiente del documento) === */}
                            <div className='dycinputFilter'>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    margin="normal"
                                    label="Referencia"
                                    name="referencia"
                                    size="small"
                                    value={tempFiltros.referencia || ""}
                                    onChange={(e) => handleReferenciaChange(e.target.value)}
                                    select
                                    disabled={!referenciasDisponibles || referenciasDisponibles.length === 0}
                                    SelectProps={{
                                        MenuProps: {
                                            PaperProps: {
                                                sx: { maxHeight: { sm: 36 * 8 + 8 } }
                                            }
                                        }
                                    }}
                                >
                                    <MenuItem value="">Todos</MenuItem>
                                    {referenciasDisponibles && referenciasDisponibles.map((ref) => (
                                        <MenuItem key={ref.id} value={ref.id}>
                                            {ref.nombre}
                                        </MenuItem>
                                    ))}
                                </TextField>
                            </div>
                        </div>
                        <div className='subiryconsultarRow'>
                            {/* === FILTROS DE FECHA === */}
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <div className="dycinputflFilter filtroDocumentosFechas">
                                    <DatePicker
                                        label="Fecha Registro Desde"
                                        format="DD-MM-YYYY"
                                        value={tempFiltros.f_registro_ini ? dayjs(tempFiltros.f_registro_ini) : null}
                                        onChange={(value) =>
                                            setTempFiltros({
                                                ...tempFiltros,
                                                f_registro_ini: value ? value.format("YYYY-MM-DD") : ""
                                            })
                                        }
                                        slotProps={{ textField: { size: "small", fullWidth: true } }}
                                    />
                                    <DatePicker
                                        label="Fecha Registro Hasta"
                                        format="DD-MM-YYYY"
                                        value={tempFiltros.f_registro_fin ? dayjs(tempFiltros.f_registro_fin) : null}
                                        onChange={(value) =>
                                            setTempFiltros({
                                                ...tempFiltros,
                                                f_registro_fin: value ? value.format("YYYY-MM-DD") : ""
                                            })
                                        }
                                        slotProps={{ textField: { size: "small", fullWidth: true } }}
                                    />
                                </div>

                                <div className="dycinputflFilter filtroDocumentosFechas">
                                    <DatePicker
                                        label="Fecha Documento Desde"
                                        format="DD-MM-YYYY"
                                        value={tempFiltros.f_documento_ini ? dayjs(tempFiltros.f_documento_ini) : null}
                                        onChange={(value) =>
                                            setTempFiltros({
                                                ...tempFiltros,
                                                f_documento_ini: value ? value.format("YYYY-MM-DD") : ""
                                            })
                                        }
                                        slotProps={{ textField: { size: "small", fullWidth: true } }}
                                    />
                                    <DatePicker
                                        label="Fecha Documento Hasta"
                                        format="DD-MM-YYYY"
                                        value={tempFiltros.f_documento_fin ? dayjs(tempFiltros.f_documento_fin) : null}
                                        onChange={(value) =>
                                            setTempFiltros({
                                                ...tempFiltros,
                                                f_documento_fin: value ? value.format("YYYY-MM-DD") : ""
                                            })
                                        }
                                        slotProps={{ textField: { size: "small", fullWidth: true } }}
                                    />
                                </div>

                                <div className="dycinputflFilter filtroDocumentosFechas">
                                    <DatePicker
                                        label="Fecha Próxima Desde"
                                        format="DD-MM-YYYY"
                                        value={tempFiltros.f_proxima_ini ? dayjs(tempFiltros.f_proxima_ini) : null}
                                        onChange={(value) =>
                                            setTempFiltros({
                                                ...tempFiltros,
                                                f_proxima_ini: value ? value.format("YYYY-MM-DD") : ""
                                            })
                                        }
                                        slotProps={{ textField: { size: "small", fullWidth: true } }}
                                    />
                                    <DatePicker
                                        label="Fecha Próxima Hasta"
                                        format="DD-MM-YYYY"
                                        value={tempFiltros.f_proxima_fin ? dayjs(tempFiltros.f_proxima_fin) : null}
                                        onChange={(value) =>
                                            setTempFiltros({
                                                ...tempFiltros,
                                                f_proxima_fin: value ? value.format("YYYY-MM-DD") : ""
                                            })
                                        }
                                        slotProps={{ textField: { size: "small", fullWidth: true } }}
                                    />
                                </div>
                            </LocalizationProvider>
                        </div>
                        {/* === FILTRO: Observaciones === */}
                        <div className="dycinputFilter inputObsFiltro">
                            <TextField
                                variant="outlined"
                                margin="normal"
                                label="Observaciones"
                                name="observacion"
                                id="observacionFiltro"
                                value={tempFiltros.observacion}
                                onChange={(e) =>
                                    setTempFiltros({ ...tempFiltros, observacion: e.target.value })
                                }
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button className="colorGrupo botonBorrarFiltros" onClick={borrarFiltros}>Limpiar Filtros</Button>
                    <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                        <Button className="colorGrupo borrarBoton" onClick={cancelFiltrar}>Cancelar</Button>
                        <Button className="colorGrupo" onClick={filtrarDocumentos}>Filtrar</Button>
                    </ButtonGroup>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default SubirYConsultar;